var endPoint =   "https://course.tatkoon.com/api" // "http://localhost:3002/api"  ////   "http://a.zhiweihomec.xyz/api" "http://localhost:3002/api"//"https://a.zhiweihomeb.com/api"  //"http://production-env.6z4xjdq7rm.ap-east-1.elasticbeanstalk.com/api"// "http://localhost:3002/api"   //"http://zhiweihomeb.com/x/api"


module.exports = endPoint;